$(document).ready(function () {
    const formatter = new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
    });
    $(document).on("click", ".cart-popup__close", function () {
        $(".cart-popup-wrapper").last().addClass("cart-popup-wrapper--hidden");
        // $(".cart-popup-wrapper").hide();
    });
    $(document).on("click", ".continue-shopping", function () {
        $(".cart-popup-wrapper").last().addClass("cart-popup-wrapper--hidden");
        // $(".cart-popup-wrapper").hide();
    });
    $(document).on("click", ".popup-cart-minus-product", function () {
        let variantId = $(this).attr("data");
        let quantity = $(
            `.cart-popup-item__quantity[data=${variantId}] span`
        ).html();
        data = {
            id: variantId,
            quantity: quantity - 1,
        };
        $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: data,
            dataType: "json",
            success: function (success) {
                if (quantity === 1 || quantity === "1") {
                    $(`.product-item[data=${variantId}]`).remove();
                } else {
                    $(
                        `.cart-popup-item__quantity[data=${variantId}] span`
                    ).html(quantity - 1);
                    if (success?.items?.length > 0) {
                        let currentProductPrice = [];
                        currentProductPrice = success?.items.filter(
                            (item) => parseInt(item.id) === parseInt(variantId)
                        );
                        if (currentProductPrice.length > 0) {
                            currentProductPrice = formatter.format(
                                currentProductPrice[0]?.final_line_price / 100
                            );
                            currentProductPrice = currentProductPrice.replace(
                                "Rp",
                                "IDR"
                            );
                            $(
                                `.product-item[data=${variantId}] .data-cart-popup-product-price`
                            ).html(currentProductPrice);
                        }
                    }
                }
                if (success.items_subtotal_price > 0) {
                    let totalAmount = formatter.format(
                        success.items_subtotal_price / 100
                    );
                    totalAmount = totalAmount.replace("Rp", "IDR");
                    $(".cart-drawer-total-amount").html(totalAmount);
                }else{
                    $(".cart-drawer-total-amount").html("");
                }
                $("#CartCount > span").html(success.item_count);
            },
            error: function (xhr) {
                var err = eval("(" + xhr.responseText + ")");
                console.log(err.Message);
            },
        });
    });

    $(document).on("click", ".popup-cart-plus-product", function () {
        let variantId = $(this).attr("data");
        let quantity = $(
            `.cart-popup-item__quantity[data=${variantId}] span`
        ).html();
        data = {
            id: variantId,
            quantity: parseInt(quantity) + 1,
        };
        $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: data,
            dataType: "json",
            success: function (success) {
                $(`.cart-popup-item__quantity[data=${variantId}] span`).html(
                    parseInt(quantity) + 1
                );
                if (success.items_subtotal_price) {
                    let totalAmount = formatter.format(
                        success.items_subtotal_price / 100
                    );
                    totalAmount = totalAmount.replace("Rp", "IDR");
                    $(".cart-drawer-total-amount").html(totalAmount);
                }
                if (success?.items?.length > 0) {
                    let currentProductPrice = [];
                    currentProductPrice = success?.items.filter(
                        (item) => parseInt(item.id) === parseInt(variantId)
                    );
                    if (currentProductPrice.length > 0) {
                        currentProductPrice = formatter.format(
                            currentProductPrice[0]?.final_line_price / 100
                        );
                        currentProductPrice = currentProductPrice.replace(
                            "Rp",
                            "IDR"
                        );
                        $(
                            `.product-item[data=${variantId}] .data-cart-popup-product-price`
                        ).html(currentProductPrice);
                    }
                }
                $("#CartCount > span").html(success.item_count);
            },
            error: function (xhr, status, message) {
                $(".group-action-cart .alert-error").show();
                setTimeout(() => {
                    $(".group-action-cart .alert-error").hide();
                }, 3000);
            },
        });
    });


    
    if ($("div#voucher-wrapper").length > 0) {
      console.log('tes')
    	let getIdGroup = $('#voucher-wrapper').attr('group');
    	let getIdCustomer = $('.get-customer-information').attr('customer-id');
    	let currentUrl = window.location.href;
      	let getUrlStore = $('#voucher-wrapper').attr('url-shopify');
        let titlePage =  $('.get-customer-information').attr('page-title');
    	$.ajax({
    		type: "POST",
    		url: "https://atmos-custom-plugin.devbdd.com/front/display_list_voucher",
    		data: { id:getIdGroup,customerId:getIdCustomer,currentUrl:currentUrl,url_shopify:getUrlStore,titlePage:titlePage },
    		success: function(response){
              console.log('response',response)
    			$('#voucher-wrapper').append(response)
    
              if(currentUrl.includes('claim=failed')){
                $('#voucher-wrapper').prepend('<div class="voucher-wrappe-failed">Claim Voucher Failed! , Pelase Login First </div>');
              }
    		}
    	});
    }
});
